import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { METODO_DE_VALORACAO_ADUANEIRA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    METODO_DE_VALORACAO_ADUANEIRA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    METODO_DE_VALORACAO_ADUANEIRA_ENDPOINT,
    id
  ]);
}
